module.exports = __webpack_public_path__ + "img/mot_freigaben.3a9be9f5.png";